<div class="sectiontitle">Jira Projects → Accounts → Tickets</div>

<div *ngIf="loading">Laden…</div>
<div *ngIf="error" class="form-error">{{ error }}</div>

<div *ngIf="!loading && !error">
  <div *ngFor="let item of results" class="m-b-4">
    <h3>{{ item.project.projectName }} (ID: {{ item.project.jiraKey }})</h3>
    <button class="button button--outline m-b-2" (click)="loadAccountsForProject(item)" [disabled]="item.loaded">
      {{ item.loaded ? 'Budgetposten getoond' : 'Toon budgetposten (Accounts)' }}
    </button>
    <div *ngIf="item.loaded && (!item.accounts || item.accounts.length === 0)" class="m-b-2">Geen budgetposten (Accounts) gevonden voor dit project.</div>
    <div *ngFor="let acc of item.accounts" class="m-b-3">
      <h4>Budgetpost: {{ acc.name }} ({{ acc.id }})</h4>
      <div *ngIf="acc.issueKeys.length === 0">Geen tickets gelinkt aan deze budgetpost.</div>
      <ul *ngIf="acc.issueKeys.length > 0">
        <li *ngFor="let key of acc.issueKeys">
          {{ key }}
        </li>
      </ul>
    </div>
  </div>
</div>
